module.exports = __webpack_public_path__ + "static/media/46.aa6c38c8.jpg";